import { render } from "./RoomValidationBadge.vue?vue&type=template&id=64f6f824"
import script from "./RoomValidationBadge.vue?vue&type=script&lang=js"
export * from "./RoomValidationBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__